'use strict';

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

var _toConsumableArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

var _defineProperty = require("/vercel/path1/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.regexp.constructor");

var _slicedToArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var deburr = require('lodash.deburr');

var escapeStringRegexp = require('escape-string-regexp');

var builtinReplacements = require('./replacements');

var builtinOverridableReplacements = require('./overridable-replacements');

var decamelize = function decamelize(string) {
  return string.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var doCustomReplacements = function doCustomReplacements(string, replacements) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return string;
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  return string.replace(new RegExp("".concat(separator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(separator, "|").concat(separator, "$"), 'g'), '');
};

var slugify = function slugify(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(typeof string, "`"));
  }

  options = _objectSpread({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: []
  }, options);
  var separator = escapeStringRegexp(options.separator);
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements), _toConsumableArray(builtinReplacements)));
  string = doCustomReplacements(string, customReplacements);
  string = deburr(string);
  string = string.normalize('NFKD');

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = /[^a-zA-Z\d]+/g;

  if (options.lowercase) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }

  string = string.replace(patternSlug, separator);
  string = string.replace(/\\/g, '');
  string = removeMootSeparators(string, separator);
  return string;
};

module.exports = slugify; // TODO: Remove this for the next major release

module.exports["default"] = slugify;